import React from "react";
import { MenuIcon } from "lucide-react";
import { ExpandableChatHeader } from "@cmp-src/primitives/chat/expandable-chat";
import { ChatButtonActions } from "@/features/tessa/components/bubble/ChatButtonActions";
import { cn } from "@gettactic/helpers";
import { useAskTessa } from "@cmp-src/tessa/AskTessaProvider";

export interface ChatBotBubbleHeaderProps {
  className?: string;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
  onPopupSidebarOpen: () => void;
  onPopupSidebarClose: () => void;
}

export const ChatBotBubbleHeader = React.forwardRef<
  HTMLDivElement,
  ChatBotBubbleHeaderProps
>(
  (
    { className, onMouseDown, style, onPopupSidebarOpen, onPopupSidebarClose },
    ref
  ) => {
    const { setSelectedChatId, selectedChatId } = useAskTessa() || {
      selectedChatId: undefined,
      setSelectedChatId: () => {}
    };
    return (
      <ExpandableChatHeader
        className={cn(
          "flex-col justify-center bg-[#EFF3F9] py-0 text-center",
          className
        )}
        onMouseDown={onMouseDown}
        style={style}
      >
        <div className={"flex w-full items-center justify-between"}>
          <div>
            {selectedChatId && (
              <button
                className="flex items-center gap-2"
                onClick={() => {
                  setSelectedChatId("");
                  onPopupSidebarOpen();
                }}
              >
                <MenuIcon className={"size-6"} />
              </button>
            )}
          </div>
          <h1
            className="flex-1 cursor-move select-none py-3 font-semibold text-xl"
            ref={ref}
          >
            Tessa
          </h1>
          <ChatButtonActions />
        </div>
      </ExpandableChatHeader>
    );
  }
);
